import { capitalizeFirstLetter } from "@app/utils";

export const convertFullTestName = (
  fullTestName: string
): string | undefined => {
  if (!fullTestName) return "";

  return capitalizeFirstLetter(fullTestName.trim().split(" ")[0]);
};
